import { useEffect } from 'react';
import { useMeasurementSystem } from '../userPreference/useMeasurementSystem';
import { useCreateCartMutation } from './mutation';
import { getCart } from './query';
import { createEmptyCart } from './utils';

const useLoadCart = (
  onLoadSuccess: (cart: CartDto) => void,
  enabled: boolean
) => {
  const { mutateAsync: createCartMutation } = useCreateCartMutation();
  const { measurementSystem } = useMeasurementSystem();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const createCart = () => {
      createCartMutation(createEmptyCart()).then(onLoadSuccess);
    };

    getCart()
      .then(onLoadSuccess)
      .catch((error) => {
        if (error.status === 404) {
          createCart();
          return;
        }
        throw error;
      });
  }, [createCartMutation, onLoadSuccess, enabled, measurementSystem]);
};

export default useLoadCart;
